import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import AddConfirmationChild from "./AddConfirmationChild";

const AddConfirmation = () => {
  return (
    <MainTemplate>
      <ErrorBoundaryRoutes route="/confirmation/add" page="AddConfirmation">
        <div className="relative flex flex-col p-10 m-3 space-y-10 bg-white rounded-md shadow md:flex-row md:space-y-0 md:m-3">
          <AddConfirmationChild />
        </div>
      </ErrorBoundaryRoutes>
    </MainTemplate>
  );
};

export default AddConfirmation;
